export function ensureHttpsProtocol(url: string): string {
  return /^https?:\/\//.test(url) ? url : `https://${url}`;
}
